export default __webpack_public_path__ + "static/media/godaddy.d9459f1.a3dbb893.svg";